export const SUPPLIER_FIELD_NAMES = {
  SUPPLIER_NAME: 'supplierName',
  SUPPLIER_EMAIL: 'supplierEmail',
  CONTACT_NAME: 'contactName',
  CONTACT_PHONE: 'contactPhone',
};
